var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
  Flickity = require('flickity');

require('flickity-as-nav-for/as-nav-for');

function ComparisonGrid(el) {
  var t = this;

  t.el = el;
  t.$el = $(el);
  t.tabCarousel = null;
  t.$toggle = t.$el.find('[data-bar-toggle]');

  t.initTabs();

  t.$toggle.on('click', function() {
    if (this.getAttribute('aria-expanded') === 'true') {
      this.setAttribute('aria-expanded', 'false')
    } else {
      this.setAttribute('aria-expanded', 'true')
    }
    t.$el.find('[data-bar-content]').slideToggle(function() {
      t.$toggle.toggleClass('js-info-bar-active');
      t.tabContentCarousel.resize();
    });
  });


}

ComparisonGrid.prototype.initTabs = function () {
  var t = this,
    tabs = t.el.querySelectorAll('[data-tab-toggle]'),
    stickyTabs = $('.sticky-header__item[data-comparison-title]'),
    tabCount = tabs.length;

  if (tabCount >= 2) {
    t.tabContentCarousel = new Flickity(t.el.querySelector('[data-tab-content]'), {
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      dragThreshold: 500,
      accessibility: false
    });

    t.tabCarousel = new Flickity(t.el.querySelector('[data-tab-toggles]'), {
      draggable: true,
      groupCells: true,
      pageDots: false,
      cellAlign: 'center',
      contain: true,
      asNavFor: '[data-tab-content]',
      arrowShape: 'M 34.222441 96.77085 28.5714286 100 0 50 28.5714286 0 34.222441 3.22914996 7.49624099 50z',
      accessibility: false
    });

    Array.prototype.map.call(tabs,(el, index) => {
      const tabList = Array.from(tabs);
      $(el).click(() => {
        t.tabContentCarousel.select(index)
      })

      el.addEventListener('keydown', (e) => {
        if ((e.key === 'ArrowRight' || e.key === 'ArrowDown')) {
          el.setAttribute('tabindex', '-1')
          el.setAttribute('aria-hidden', 'true')

          if (index === tabCount - 1) {
            tabList[0].removeAttribute('tabIndex')
            tabList[0].removeAttribute('aria-hidden')
            tabList[0].focus()
          } else {
            tabList[index + 1].tabIndex = 0
            tabList[index + 1].setAttribute('aria-hidden', 'false')
            tabList[index + 1].focus()
          }
        }

        if ((e.key === 'ArrowLeft' || e.key === 'ArrowUp')) {
          el.setAttribute('tabindex', '-1')
          el.setAttribute('aria-hidden', 'true')

          if (index === 0) {
            tabList[tabCount - 1].removeAttribute('tabIndex')
            tabList[tabCount - 1].removeAttribute('aria-hidden')
            tabList[tabCount - 1].focus()
          } else {
            tabList[index - 1].removeAttribute('tabIndex')
            tabList[index - 1].setAttribute('aria-hidden', 'false')
            tabList[index - 1].focus()
          }
        }
      })
    })

    Array.prototype.map.call(stickyTabs,(el, index) => {
      $(el).click(() => {
        t.tabContentCarousel.select(index)
      })
    })

    $(window).on('load', function() {
      t.tabContentCarousel.resize();
      t.tabCarousel.resize();
    });

    t.$el.find('.accordion__item').on('accordion.slideProgress', function() {
      t.tabContentCarousel.resize();
    });
  }
};

module.exports = ComparisonGrid;
